import React from 'react'
import Table from '../components/Table/Table'
import { useNavigate } from 'react-router'

const OrganizationRequests = () => {
    const [organizationRequests, setOrganizationRequests] = React.useState([])
    const [isloading, setIsloading] = React.useState(false)
    const navigate = useNavigate()

    React.useEffect(() => {
        fetchOrganizationCreateRequests()
    }, [])

    const fetchOrganizationCreateRequests = async () => {
        setIsloading(true)
        setTimeout(() => {
            const dummyData = [
                {
                    name: "Org A",
                    id: 1,
                    verify_attempts: 2,
                    email: "orga@example.com",
                    contact_person: "John Doe",
                    status: "Pending",
                    phone: "123-456-7890",
                    company: "Example Corp",
                    last_login: "2023-10-01T12:34:56Z",
                    address_one: "123 Main St",
                    country: "USA"
                }
            ]
            setOrganizationRequests(dummyData)
            setIsloading(false)
        }, 1000)
    }

    const columns = [
        {
          key: "organizationName",
          header: "Organization Name",
          cell: (org) => org?.name,
        },
        {
            key: "id",
            header: "ID",
            cell: (org) => org?.id || "N/A",
        },
        {
            key: "verify_attempts",
            header: "Verify Attempts",
            cell: (org) => org?.verify_attempts || 0,
        },
        {
          key: "organizationEmail",
          header: "Organization Email",
          cell: (org) => org?.email,
        },
        {
            key: "contactPerson",
            header: "Contact Person",
            cell: (org) => org?.contact_person || "None",
        },
        {
            key: "status",
            header: "Status",
            cell: (org) => org?.status || "Pending",
        },

        {
          key: "phone",
          header: "Phone Number",
          cell: (org) => org?.phone,
        },
        {
          key: "company",
          header: "Company",
          cell: (org) => org?.company || "None",
        },
        {
            key: "lastActivity",
            header: "Last Activity",
            cell: (org) => org?.last_login ? new Date(org.last_login).toLocaleString() : "None",
        },
        {
            key: "address",
            header: "Address",
            cell: (org) => org?.address_one || "None",
        },
        {
            key: "country",
            header: "Country",
            cell: (org) => org?.country || "None",
        }
    ]
    return (
        <div>
            <Table
                data={organizationRequests}
                columns={columns}
                keyExtractor={(org) => org.email}
                isLoading={isloading}
                onRowClick={(org) => navigate('/organization/request/' + org?.id)}
                emptyState={<div className="text-center p-4">No Data Found</div>}
            />
        </div>
    )
}


export default OrganizationRequests
